<template>
    <div class="credito">
        <Header />
        <CallToAction
            @openModal="showModal = true"
            id="call-to-action"
            @successAlert="successAlert"
            @errorAlert="errorAlert"
        />
        <Modal
            :showModal="showModal"
            @closeModal="showModal = false"
            @successAlert="successAlert"
            @errorAlert="errorAlert"
        />
        <Benefits id="vantagens" />
        <HowItWorks id="como-funciona" />
        <WhatsAppButton />
        <Footer @openModal="showModal = true" id="solicitar-proposta" />
    </div>
</template>

<script>
import Header from '@/components/credito/header';
import CallToAction from '@/components/credito/call-to-action';
import Modal from '@/components/credito/modal';
import Benefits from '@/components/credito/benefits';
import HowItWorks from '@/components/credito/how-it-works';
import WhatsAppButton from '@/components/credito/WhatsAppButton';
import Footer from '@/components/credito/footer';
import Swal from 'sweetalert2';

export default {
    name: 'EngelinkCredito',
    components: { Header, CallToAction, Modal, Benefits, HowItWorks, WhatsAppButton, Footer },
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        successAlert() {
            Swal.fire({
                toast: true,
                title: 'Proposta enviada com sucesso!',
                icon: 'success',
                showConfirmButton: false,
                timerProgressBar: true,
                timer: 3000,
                position: 'bottom',
            });
        },
        errorAlert() {
            Swal.fire({
                toast: true,
                title: 'Erro interno nos servidores',
                icon: 'error',
                showConfirmButton: false,
                timerProgressBar: true,
                timer: 3000,
                position: 'bottom',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.credito {
    display: grid;
    grid-template-columns: 1fr;
}
</style>
